/* global axios */

import ApiClient from './ApiClient';

class InternalChat extends ApiClient {
  constructor() {
    super('internal_chat_messages', { accountScoped: true });
  }

  getMessages() {
    return axios.get(this.url);
  }

  getMembers() {
    return axios.get(`${this.url}/members`);
  }

  sendMessage({
    content = '',
    replyToId = null,
    mentionedUserIds = [],
    files = [],
  }) {
    const formData = new FormData();

    formData.append('internal_chat_message[content]', content);

    if (replyToId) {
      formData.append('internal_chat_message[reply_to_id]', replyToId);
    }

    mentionedUserIds.forEach(userId => {
      formData.append(
        'internal_chat_message[mentioned_user_ids][]',
        userId
      );
    });

    files.forEach(file => {
      formData.append('internal_chat_message[files][]', file);
    });

    return axios.post(this.url, formData);
  }

  getUnreadCount() {
    return axios.get(`${this.url}/unread_count`);
  }

  markRead() {
    return axios.post(`${this.url}/mark_read`);
  }
}

export default new InternalChat();
